export const WARNING_DIALOG = {
    MESSAGE: "warning-dialog-message",
};
